module.exports = __webpack_public_path__ + "static/media/a6.58d1c1cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/a6.png
// module id = 235
// module chunks = 108